import { combineReducers } from "redux";
import {fetching, items } from "./resource";

export default combineReducers({
  isFetching: fetching("requirementConditions"),
  items: items("requirementConditions"),
});
